import type { AppConfig } from 'nuxt/schema'
import loadScriptAsync from '../loadScriptAsync'
import debug from '../console'
const logger = debug.withTag('utils:preAYScripts')

export const preAYScripts = async (config: AppConfig['adops']) => {
  const { boltive } = config
  if (boltive.scriptUrl) {
    try {
      await loadScriptAsync('head', {
        src: boltive.scriptUrl,
        key: 'boltive',
      })
    } catch (error) {
      logger.warn(
        'Failed to load Boltive script, continuing without ad fraud protection',
        error
      )
    }
  }

  // load gamera - tracks ads per minute, ad density etc
  try {
    await loadScriptAsync('head', {
      src: `https://metrics.rapidedge.io/gamera.js?ltv=1&audience=1&tpcs=1&partner=duplex`,
      key: '__gamera__',
    })
  } catch (error) {
    logger.warn(
      'Failed to load Gamera analytics script, continuing without ad metrics',
      error
    )
  }

  // load liveramp - a user data module
  try {
    await loadScriptAsync(
      'head',
      {
        src: `https://launchpad-wrapper.privacymanager.io/528606c5-a8ba-42f7-be55-93209da0477d/launchpad-liveramp.js`,
        key: 'liveramp',
      },
      { defer: true }
    )
  } catch (error) {
    logger.warn(
      'Failed to load LiveRamp identity module, continuing without enhanced targeting',
      error
    )
  }
}
